<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <div class="text-left pt-4">
          <h4>Datos Personales</h4>
        </div>
        <!-- NOMBRES -->
        <div v-if="isFieldVisible('first_names')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="first_names" class="form-label text-left">{{ getFieldDescription('first_names') }}</label>
            <input
              type="text"
              class="form-control"
              name="first_names"
              v-model="formData.first_names"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('first_names')"
            />
          </div>
        </div>
        <!-- APELLIDOS -->
        <div v-if="isFieldVisible('last_names')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="last_names" class="form-label text-left">{{ getFieldDescription('last_names') }}</label>
            <input
              type="text"
              class="form-control"
              name="last_names"
              v-model="formData.last_names"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('last_names')"
            />
          </div>
        </div>
        <!-- EDAD -->
        <div v-if="isFieldVisible('age')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="age" class="form-label text-left">{{ getFieldDescription('age') }}</label>
            <input
              type="text"
              class="form-control"
              name="age"
              v-model="formData.age"
              required="required"
              maxlength="3"
              @input="() => emitFieldChanged('age')"
            />
          </div>
        </div>
        <!-- DNI -->
        <div v-if="isFieldVisible('dni')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="dni" class="form-label text-left">{{ getFieldDescription('dni') }}</label>
            <input
              type="text"
              class="form-control"
              name="dni"
              v-model="formData.dni"
              required="required"
              maxlength="8"
              @input="() => emitFieldChanged('dni')"
            />
          </div>
        </div>
        <!-- EMAIL -->
        <div v-if="isFieldVisible('email')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="email" class="form-label text-left">Email</label>
            <input
              type="text"
              class="form-control"
              name="email"
              v-model="formData.email"
              required="required"
              maxlength="255"
              @input="() => emitFieldChanged('email')"
            />
          </div>
        </div>
        <!-- TEL -->
        <div v-if="isFieldVisible('cellphone')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="tel" class="form-label text-left">{{ getFieldDescription('cellphone') }}</label>
            <input
              type="tel"
              class="form-control"
              name="tel"
              v-model="formData.cellphone_number"
              required="required"
              maxlength="10"
              @input="() => emitFieldChanged('cellphone_number')"
            />
          </div>
        </div>
        <!-- DIRECCION -->
        <div v-if="isFieldVisible('address_street')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="address_street" class="form-label text-left">{{ getFieldDescription('address_street') }}</label>
            <input
              type="text"
              class="form-control"
              name="address_street"
              v-model="formData.address_street"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('address_street')"
            />
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormPersonal',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      first_names: null,
      last_names: null,
      age: null,
      dni: null,
      email: null,
      cellphone_number: null,
      address_street: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.first_names ||
            dataCompany.value.last_names ||
            dataCompany.value.age ||
            dataCompany.value.dni ||
            dataCompany.value.email ||
            dataCompany.value.address_street ||
            dataCompany.value.cellphone)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
    };
  },
};
</script>

<!-- <template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <div
          v-for="([key]) in visibleFormDataEntries"
          :key="key"
          class="col-md-3 mt-3"
        >
          <div class="form-group bordered">
            <label :for="key" class="form-label text-left">
              {{ getFieldDescription(key) }}
            </label>
            <input
              :type="key === 'cellphone_number' ? 'tel' : 'text'"
              class="form-control"
              :name="key"
              v-model="formData[key]"
              :maxlength="maxLengths[key]"
              @input="handleInputChange(key)"
              :required="requiredFields.includes(key)"
            />
            <small v-if="errors[key]" class="text-danger">{{ errors[key] }}</small>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
</template> -->

<!-- <script>
import { ref, onMounted, computed } from 'vue';

export default {
  name: 'FormPersonal',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      first_names: null,
      last_names: null,
      age: null,
      dni: null,
      email: null,
      cellphone_number: null,
      address_street: null,
    });

    // Definimos los maxlength reactivos por campo
    const maxLengths = {
      first_names: 3,
      last_names: 150,
      age: 3,
      dni: 15,
      email: 100,
      cellphone_number: 15,
      address_street: 200,
    };

    // Campos requeridos, podes agregar o quitar
    const requiredFields = [
      'first_names',
      'last_names',
      'age',
      'dni',
      'email',
      'cellphone_number',
      'address_street',
    ];

    // Para almacenar mensajes de error por campo
    const errors = ref({});

    // Computed que devuelve solo los campos visibles filtrados
    const visibleFormDataEntries = computed(() => {
      return Object.entries(formData.value).filter(([key]) =>
        isFieldVisible(key)
      );
    });

    const cargarDatos = () => {
      try {
        showComponentData.value =
          dataCompany.value &&
          (dataCompany.value.first_names ||
            dataCompany.value.last_names ||
            dataCompany.value.age ||
            dataCompany.value.dni ||
            dataCompany.value.email ||
            dataCompany.value.address_street ||
            dataCompany.value.cellphone);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);

      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    // Validación simple: chequea que campos requeridos no estén vacíos y no pasen maxlength
    const validateField = (key) => {
      const value = formData.value[key];
      let error = '';

      // Validar requerido
      if (requiredFields.includes(key)) {
        if (value === null || value === undefined || value.toString().trim() === '') {
          error = 'Este campo es obligatorio';
        }
      }

      // Validar maxlength solo si no hay error y valor existe
      if (!error && value !== null && value !== undefined && maxLengths[key]) {
        if (value.toString().length > maxLengths[key]) {
          error = `No debe exceder ${maxLengths[key]} caracteres`;
        }
      }

      // Para que Vue detecte el cambio, hacemos asignación reactiva
      errors.value = {
        ...errors.value,
        [key]: error,
      };

      return error === '';
    };

    // Maneja cambios de input por campo
    const handleInputChange = (key) => {
      validateField(key);
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      maxLengths,
      requiredFields,
      errors,
      visibleFormDataEntries,
      handleInputChange,
    };
  },
};
</script>  -->


 
